// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:max-line-length (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import BaseComponent from '../../../../base/base-component';
import { CSSTransitionGroup as CssTransitionGroup } from 'react-transition-group';
import Color from 'color';
import { IRostelecomStyleParamsStoreState } from '../../styling/rostelecom-styles-store';
import './rostelecom-dialog-container.less';
import Radium from '../../styling/rostelecom-radium';
import windowSizeStore from '../../../../../services/window-size/window-size-store';
import LoaderComponent from '../../reusable/loader';
import deviceFeaturesStore, {
    IDeviceFeaturesStore
} from '../../../../../services/feature-detection/device-features-store';
import { IReactRadiumFreeStyles } from '../../../../base/radium-types';
import styled from 'styled-components';

export interface IRostelecomDialogContainerProps {
    visible: boolean;
    allowClose: boolean;
    addPadding: boolean;
    style?: any;
    width: number;
    height: number;
    styles: IRostelecomStyleParamsStoreState;
    children?: any;
    heightShift?: number;
    processing?: boolean;
    zIndexShift?: number;
    innerCloseBtn?: boolean;
    dialogContentOverflow?: 'auto' | 'visible' | 'hidden';
    onClose(): void;
}

export interface IRostelecomDialogContainerState {
    windowSize: {
        width: number;
        height: number;
    };
    hover: boolean;
    device?: IDeviceFeaturesStore;
}

const DialogContent = styled.div<{ styleParams: IRostelecomStyleParamsStoreState }>`
    ::-webkit-scrollbar-track {
        // border-radius: 10px;
    }

    ::-webkit-scrollbar {
        width: 12px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: ${p => p.styleParams.neutralColor};
    }
`;

@Radium
class RostelecomDialogContainer extends BaseComponent<
    IRostelecomDialogContainerProps,
    IRostelecomDialogContainerState
> {
    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, options) {
        super(props, options);
        this.stores = {
            windowSize: windowSizeStore,
            device: deviceFeaturesStore
        };
        this.initialize();
    }

    // tslint:disable-next-line:typedef (autogenerated)
    private getSize() {
        const { heightShift = 31 } = this.props;
        const heightScale = Radium.getHeightScale();
        const widthScale = Radium.getWidthScale();
        const height = Math.min(
            this.state.windowSize.height / heightScale - 10 - heightShift,
            this.props.height
        );
        const width = Math.min(this.state.windowSize.width / widthScale - 10, this.props.width);
        return { width, height };
    }

    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styles;
        const { heightShift = 31, zIndexShift = 0 } = this.props;
        const neutralColor = Color(styleParams.neutralColor)
            .darken(0.25)
            .rgbString();
        const { width, height } = this.getSize();
        const overflow = this.props.dialogContentOverflow || 'auto';
        return {
            modalBackground: {
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
                margin: 0,
                padding: 0,
                zIndex: 99000 + zIndexShift,
                backgroundColor: Color(styleParams.baseDarkColor)
                    .alpha(0.75)
                    .rgbString()
            },
            dialogContent: {
                overflow,
                width: '100%',
                height: '100%'
            } as React.CSSProperties,
            dialogOuter: {
                color: neutralColor,
                position: 'fixed',
                borderRadius: 2,
                top: '50%',
                left: '50%',
                marginTop: -(height + heightShift) / 2,
                marginLeft: -width / 2,
                width,
                height,
                paddingTop: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingBottom: 0,
                zIndex: 99100 + zIndexShift,
                backgroundColor: styleParams.baseLightColor
            },
            innerPadding: {
                paddingTop: 20,
                paddingLeft: 40,
                paddingRight: 40,
                paddingBottom: 20
            },
            closeDiv: {
                transition: 'opacity 0.15s ease-out',
                opacity: 0,
                position: 'absolute',
                right: 0,
                top: 0,
                width: 40,
                height: 40,
                zIndex: 50,
                backgroundColor: Color(styleParams.neutralColor)
                    .darken(0.8)
                    .alpha(0.5)
                    .rgbString(),
                borderRadius: '0 0 0 4px',
                textAlign: 'center'
            },
            closeInnerSvg: {
                display: 'inline-block',
                height: 30,
                margin: '5px 0',
                stroke: styleParams.baseLightColor,
                fill: styleParams.baseLightColor,
                transition: 'stroke 0.15s ease-out, fill 0.15s ease-out',
                cursor: 'pointer',
                ':hover': {
                    stroke: styleParams.neutralColor,
                    fill: styleParams.neutralColor
                }
            },
            closeBtn: {
                position: 'absolute',
                rightFix: -17,
                top: 5,
                widthFix: 40,
                height: 60
            },
            closeBack: {
                fill: styleParams.baseLightColor,
                widthFix: 20,
                height: 50,
                stroke: 'none',
                zIndex: 10,
                position: 'absolute',
                leftFix: 22,
                top: 5
            },
            closeSvg: {
                widthFix: 40,
                height: 60,
                zIndex: 20,
                position: 'absolute',
                left: 0,
                top: 0,
                stroke: neutralColor,
                strokeWidth: 25,
                fill: 'none',
                cursor: 'pointer',
                transition: 'stroke 0.15s ease-out',
                ':hover': {
                    stroke: styleParams.baseMediumDarkColor
                }
            },
            spinnerContainer: {
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
                margin: 0,
                zIndex: 100500 + zIndexShift,
                backgroundColor: Color(styleParams.baseDarkColor)
                    .alpha(0.75)
                    .rgbString()
            },
            spinnerInner: {
                position: 'absolute',
                top: '40%',
                left: '40%',
                width: '20%',
                height: '20%'
            }
        };
    }

    // tslint:disable-next-line:member-access (autogenerated)
    onCloseClick = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    // tslint:disable-next-line:typedef (autogenerated)
    private renderClose() {
        const styles = this.getStyles();
        if (this.props.innerCloseBtn) {
            const addStyleDiv =
                this.state.hover || this.state.device.features.isIos
                    ? {
                          opacity: 1
                      }
                    : {};
            return (
                <div key="close-button" style={{ ...styles.closeDiv, ...addStyleDiv }}>
                    <svg
                        key="close"
                        viewBox="-6 -6 30 30"
                        style={styles.closeInnerSvg}
                        onClick={this.onCloseClick}
                    >
                        <path
                            opacity="0.2"
                            d="M10.484,9.013l4.939-4.94c0.586-0.585,0.586-1.536,0-2.121c-0.586-0.586-1.535-0.586-2.121,0L8.363,6.892 L3.423,1.952c-0.586-0.586-1.535-0.586-2.121,0c-0.586,0.585-0.586,1.536,0,2.121l4.939,4.94l-4.939,4.939 c-0.586,0.585-0.586,1.535,0,2.121c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l4.939-4.939l4.939,4.939 c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439c0.586-0.586,0.586-1.536,0-2.121L10.484,9.013z"
                        />
                        <path d="M10.484,8.013l4.939-4.94c0.586-0.585,0.586-1.536,0-2.121c-0.586-0.586-1.535-0.586-2.121,0L8.363,5.892 L3.423,0.952c-0.586-0.586-1.535-0.586-2.121,0c-0.586,0.585-0.586,1.536,0,2.121l4.939,4.94l-4.939,4.939 c-0.586,0.585-0.586,1.535,0,2.121c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l4.939-4.939l4.939,4.939 c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439c0.586-0.586,0.586-1.536,0-2.121L10.484,8.013z" />
                    </svg>
                </div>
            );
        }
        return (
            <div style={styles.closeBtn} onClick={this.onCloseClick}>
                <svg viewBox="0 0 100 250" style={styles.closeBack}>
                    <path d="M0,0 l0,250c0,-20 0,-20 10,-35l10,-15c50,-75 50,-75 0,-150l-10,-15c-10,-15 -10,-15, -10,-35" />
                </svg>
                <svg viewBox="-170 -150 380 400" style={styles.closeSvg}>
                    <path d="M10,10 L90,90 M10,90 L90,10" />
                </svg>
            </div>
        );
    }

    // tslint:disable-next-line:typedef (autogenerated)
    private renderModalBackground() {
        if (!this.props.visible) {
            return;
        }
        const styles = this.getStyles();
        return (
            <div
                key="modal-background"
                className="modal-container-background"
                style={styles.modalBackground}
            />
        );
    }

    // tslint:disable-next-line:typedef (autogenerated)
    private renderDialog() {
        if (!this.props.visible) {
            return <span key="dialog-container-stub" />;
        }
        const styles = this.getStyles();
        const { children, addPadding, allowClose } = this.props;
        const elements = allowClose ? this.renderClose() : [];
        const innerAdd = addPadding ? styles.innerPadding : {};
        const hoverProps = {
            onMouseOver: () => {
                this.updateState({
                    hover: true
                });
            },
            onMouseOut: () => {
                this.updateState({
                    hover: false
                });
            }
        };
        return (
            <div
                key="dialog-container"
                className="modal-container-dialog"
                style={{ ...styles.dialogOuter, ...innerAdd, ...this.props.style }}
                {...hoverProps}
            >
                {elements}
                <DialogContent styleParams={this.props.styles} style={styles.dialogContent}>
                    {children}
                </DialogContent>
            </div>
        );
    }

    private renderSpinner(): any {
        const styles = this.getStyles();

        if (this.props.processing && this.props.visible) {
            return (
                <div
                    key="spinner_container"
                    className="modal-container-background"
                    style={styles.spinnerContainer}
                >
                    <div style={styles.spinnerInner}>
                        <LoaderComponent
                            {...{
                                styles: this.props.styles
                            }}
                        />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    // tslint:disable-next-line:typedef member-access (autogenerated)
    render() {
        return (
            <div>
                <CssTransitionGroup
                    component="div"
                    transitionName="modal-container-transition"
                    transitionEnterTimeout={300}
                    transitionLeaveTimeout={300}
                >
                    {this.renderModalBackground()}
                    {this.renderDialog()}
                    {this.renderSpinner()}
                </CssTransitionGroup>
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default RostelecomDialogContainer;
